var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 611.27 377.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-16,.cls-2{fill:#252830;}.cls-3{fill:#d7d7dd;}.cls-4{fill:#cdcdd1;}.cls-5{fill:#eb5623;}.cls-6,.cls-9{fill:none;stroke-linecap:round;}.cls-6{stroke:#ffda04;stroke-miterlimit:10;}.cls-7{fill:#fbb019;}.cls-8{fill:#ffda04;}.cls-9{stroke:#fff;stroke-linejoin:round;}.cls-10,.cls-13{fill:#fffbf2;}.cls-11{fill:#ffae5e;}.cls-12,.cls-14,.cls-19{fill:#606060;}.cls-12{opacity:0.1;}.cls-12,.cls-14{mix-blend-mode:multiply;}.cls-13,.cls-14{opacity:0.3;}.cls-13{mix-blend-mode:screen;}.cls-15{fill:#f0c600;opacity:0.5;}.cls-16{font-size:60.91px;font-family:SFProDisplay-Bold, SF Pro Display;font-weight:700;}.cls-17{letter-spacing:0em;}.cls-18{fill:#474745;}.cls-20{fill:#fff;}.cls-21{fill:#ff924d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pic 404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462.73,305.05c42.54,8.63,6.7,19-80.06,23.17s-191.59.54-234.13-8.09-6.7-19,80.06-23.17S420.19,296.42,462.73,305.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.14,61v8.38H159V61a2.17,2.17,0,0,1,0-.36,9.27,9.27,0,0,1,9.27-8.93h15.57A9.28,9.28,0,0,1,193.14,61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 165.62,
    y: 68.25,
    width: 20.89,
    height: 229.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 143.97,
    y: 297.56,
    width: 64.2,
    height: 17.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.17,297.56v17.27H175.88a12.36,12.36,0,0,0-12.22-10.38H144v-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.14,61v8.38h-6.63V297.66H176.05a18.79,18.79,0,0,0-3.24-10.06,19.2,19.2,0,0,0-6.72-6.1l-.47-.24V261.88h10.45V197.22a19.36,19.36,0,0,0-3.32-10.87,19,19,0,0,0-7.13-6.34V160.83h10.45V79.28a18.49,18.49,0,0,0-2.83-9.86,9.25,9.25,0,0,0-.79-1.17,15.29,15.29,0,0,0-1.9-2.22,18.87,18.87,0,0,0-5.92-4A18.24,18.24,0,0,0,159,60.68a9.27,9.27,0,0,1,9.27-8.93h15.57A9.28,9.28,0,0,1,193.14,61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 176.3,
    cy: 26.45,
    r: 26.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.88,37.43a22.42,22.42,0,0,1-7,7.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.07,48.15a22.13,22.13,0,0,1-4.92.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.94,13.54A23,23,0,0,1,160,11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.25,7.52a22.46,22.46,0,0,1,23.15-.58"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 176.3,
    cy: 26.45,
    r: 17.95,
    transform: "translate(24.69 120.23) rotate(-40.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 176.3,
    cy: 26.45,
    r: 11.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.54,195.9v16.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.54,288.63v6.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M452.27,61v8.38H418.13V61a2.17,2.17,0,0,1,0-.36,9.27,9.27,0,0,1,9.27-8.93H443A9.28,9.28,0,0,1,452.27,61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 424.76,
    y: 68.25,
    width: 20.89,
    height: 229.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 403.1,
    y: 297.56,
    width: 64.2,
    height: 17.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M467.3,297.56v17.27H435a12.36,12.36,0,0,0-12.22-10.38H403.1v-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M452.27,61v8.38h-6.63V297.66H435.18A18.7,18.7,0,0,0,432,287.6a19.23,19.23,0,0,0-6.73-6.1l-.46-.24V261.88H435.2V197.22a19.35,19.35,0,0,0-3.31-10.87,19.1,19.1,0,0,0-7.13-6.34V160.83H435.2V79.28a18.49,18.49,0,0,0-2.83-9.86,8.3,8.3,0,0,0-.79-1.17,14.69,14.69,0,0,0-1.9-2.22,18.71,18.71,0,0,0-5.91-4,18.38,18.38,0,0,0-5.62-1.37,9.27,9.27,0,0,1,9.27-8.93H443A9.28,9.28,0,0,1,452.27,61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 435.43,
    cy: 26.45,
    r: 26.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455,37.43a22.55,22.55,0,0,1-7,7.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M441.21,48.15a22.22,22.22,0,0,1-4.93.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M417.08,13.54A22.94,22.94,0,0,1,419.15,11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M423.38,7.52a22.46,22.46,0,0,1,23.15-.58"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 435.43,
    cy: 26.45,
    r: 17.95,
    transform: "translate(301.38 441.58) rotate(-75.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 435.43,
    cy: 26.45,
    r: 11.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M428.67,195.9v16.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M428.67,288.63v6.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 131.1,
    y: 220.27,
    width: 349.06,
    height: 50.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "169.61 220.27 131.1 258.85 131.1 238.13 148.92 220.27 169.61 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "210.13 220.27 159.55 270.95 138.84 270.95 189.42 220.27 210.13 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "250.63 220.27 200.05 270.95 179.36 270.95 229.95 220.27 250.63 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "291.16 220.27 240.57 270.95 219.87 270.95 270.45 220.27 291.16 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "331.68 220.27 281.1 270.95 260.39 270.95 310.98 220.27 331.68 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "372.19 220.27 321.6 270.95 300.89 270.95 351.48 220.27 372.19 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "412.71 220.27 362.13 270.95 341.42 270.95 392 220.27 412.71 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "453.21 220.27 402.63 270.95 381.94 270.95 432.53 220.27 453.21 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "480.16 220.27 480.16 233.88 443.15 270.95 422.45 270.95 473.03 220.27 480.16 220.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "480.16 253.72 480.16 270.95 462.97 270.95 480.16 253.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M480.16,220.27V271H378.45a112.88,112.88,0,0,0-82.77-36H131.1V220.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 131.11,
    y: 68.25,
    width: 349.06,
    height: 101.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "192.19 68.25 131.1 129.46 131.1 96.86 159.67 68.25 192.19 68.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "257.26 68.25 156.11 169.6 131.1 169.6 131.1 162.05 224.72 68.25 257.26 68.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "322.31 68.25 221.16 169.6 188.64 169.6 289.79 68.25 322.31 68.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "387.38 68.25 286.23 169.6 253.71 169.6 354.85 68.25 387.38 68.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "452.45 68.25 351.3 169.6 318.75 169.6 419.9 68.25 452.45 68.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "480.16 73.06 480.16 105.64 416.35 169.6 383.82 169.6 480.16 73.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "480.16 141.64 480.16 169.6 452.26 169.6 480.16 141.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M317.16,153.18h-163A10.15,10.15,0,0,1,144,143h0a10.15,10.15,0,0,1,10.15-10.15h163A10.16,10.16,0,0,1,327.32,143h0A10.16,10.16,0,0,1,317.16,153.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M276.75,263.88H154.12A10.15,10.15,0,0,1,144,253.72h0a10.15,10.15,0,0,1,10.15-10.16H276.75a10.15,10.15,0,0,1,10.15,10.16h0A10.15,10.15,0,0,1,276.75,263.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M131.1,68.25V98.84H295.68a112.82,112.82,0,0,1,49.93,11.57L286.42,169.6H376.2l22.93-22.94a113,113,0,0,1,12.59,22.94h68.44V68.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M406.65,123.66a9,9,0,0,1-2.53,4.74l-41.18,41.2h-57.3V68.25H357l47.13,47.14A9.2,9.2,0,0,1,406.65,123.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M396.55,119a6.89,6.89,0,0,1-2,4.87l-89.83,89.83a6.87,6.87,0,0,1-9.71,0l-89.83-89.83a6.87,6.87,0,0,1,0-9.71l68.9-68.88L295,24.34a6.87,6.87,0,0,1,9.71,0l89.83,89.83A6.84,6.84,0,0,1,396.55,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M396.55,119a6.89,6.89,0,0,1-2,4.87l-89.83,89.83a6.87,6.87,0,0,1-9.71,0l-17.13-17.13,37.35-37.37a51.45,51.45,0,0,0,0-72.77L274.07,45.29,295,24.34a6.87,6.87,0,0,1,9.71,0l89.83,89.83A6.84,6.84,0,0,1,396.55,119Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(240.64 141.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17"
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.32,
    y: 0
  }, "04")), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M223.05,121.92a2.61,2.61,0,1,1,2.6-2.6A2.6,2.6,0,0,1,223.05,121.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M223.57,121.92a2.61,2.61,0,1,1,2.61-2.6A2.59,2.59,0,0,1,223.57,121.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376.72,116.71a2.61,2.61,0,1,1-2.6,2.61A2.6,2.6,0,0,1,376.72,116.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 376.2,
    cy: 119.32,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M299.86,206.89a7.27,7.27,0,0,1-5.17-2.14l-80.56-80.56a7.32,7.32,0,0,1,0-10.34l80.56-80.56a7.48,7.48,0,0,1,10.33,0l80.57,80.56a7.32,7.32,0,0,1,0,10.34L305,204.75A7.23,7.23,0,0,1,299.86,206.89Zm0-173.42a5,5,0,0,0-3.53,1.46l-80.56,80.56a5,5,0,0,0,0,7.06l80.56,80.56a5.09,5.09,0,0,0,7.05,0L384,122.55a5,5,0,0,0,0-7.06L303.38,34.93A5,5,0,0,0,299.86,33.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.59,350.18c17.63,9.62,2.77,21.19-33.17,25.84s-79.37.61-97-9-2.77-21.19,33.17-25.84S120,340.55,137.59,350.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M145.06,354.25c-.41-1.77-.81-3.55-1.22-5.32a5.05,5.05,0,0,1,.12,1.28,5,5,0,0,0-.12-1.28,10.55,10.55,0,0,0-2.58-4.69c-.26-.28-.62-.66-.91-.92-.57-.49-1.34-1.12-1.94-1.57a28.81,28.81,0,0,0-2.54-1.62c-1-.54-2.37-1.24-3.41-1.71s-2.1-.91-3-1.25c-1.77-.64-4.18-1.41-6-1.95-1.16-.35-2.74-.74-3.92-1-2.68-.67-7-1.48-8-1.64-1.29-.21-3-.52-4.3-.69-2.69-.36-6.28-.82-9-1.09a226.28,226.28,0,0,0-24.33-1c-3.61.06-3.61.06-10,.36-1.48.07-3.45.24-4.93.35s-4.54.38-9.73,1c-.41.06-4.19.55-8.76,1.43-2.3.44-5.34,1.16-7.62,1.73a70.64,70.64,0,0,0-10.06,3.41,36,36,0,0,0-4.75,2.47,20.81,20.81,0,0,0-3.57,2.72,13.17,13.17,0,0,0-1.38,1.52,11.45,11.45,0,0,0-.91,1.36,9.72,9.72,0,0,0-.62,1.28,8.42,8.42,0,0,0-.38,1.24,4.52,4.52,0,0,0-.08.63,4.52,4.52,0,0,1,.08-.63c-.42,1.77-.83,3.54-1.25,5.32-.73,3.16,1.4,6.42,6.79,9.48,16.44,9.34,57,13.26,90.51,8.75C132.65,368.85,146.75,361.61,145.06,354.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M134.19,339.82c15.34,8.71,2.41,19.19-28.87,23.39s-69.06.56-84.4-8.16-2.41-19.19,28.86-23.39S118.85,331.11,134.19,339.82Zm-15.59,2.1c-11.12-6.32-38.5-9-61.17-5.92S25.4,346.64,36.51,353s38.5,9,61.17,5.92,32-10.64,20.92-16.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M89.74,228.76a6.39,6.39,0,0,0-3.1-3.77,14,14,0,0,0-5.47-1.58,29.79,29.79,0,0,0-7.19,0,12.46,12.46,0,0,0-5.6,1.84,6.61,6.61,0,0,0-1.69,1.62,5.89,5.89,0,0,0-.88,1.81c-.17.58.2,1.18,1.19,1.73,2.92,1.66,10.11,2.36,16.06,1.56C87.61,231.4,90.12,230.09,89.74,228.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32,346.36c1-3.53,2.37-8.24,3.38-11.76.51-1.77,1.19-4.12,1.69-5.89L40.44,317c1-3.53,2.36-8.23,3.38-11.76l1.69-5.89c1-3.52,2.37-8.23,3.38-11.76l3.39-11.76c.5-1.77,1.18-4.12,1.69-5.88,1-3.53,2.37-8.24,3.38-11.77s2.37-8.23,3.38-11.76c.51-1.77,1.19-4.12,1.69-5.88,1-3.53,2.37-8.24,3.39-11.77-.17.58.2,1.18,1.19,1.73,2.92,1.66,10.11,2.36,16.06,1.56,4.55-.61,7.06-1.92,6.68-3.25h0c1,3.54,2.34,8.25,3.34,11.78l3.34,11.77c1,3.54,2.34,8.25,3.34,11.78l3.34,11.77c1,3.54,2.34,8.25,3.34,11.78l3.34,11.77,1.67,5.89c1,3.53,2.33,8.24,3.34,11.78s2.33,8.24,3.34,11.77l1.66,5.89c1,3.53,2.34,8.24,3.34,11.77,1.43,5-8.12,10-25.45,12.36-22.67,3.05-50.05.4-61.17-5.92C32.77,350.83,31.35,348.55,32,346.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M105.2,283.26c.86,3.05-4.91,6.06-15.37,7.46-13.69,1.85-30.23.25-36.94-3.57-2.26-1.28-3.12-2.65-2.74-4,1-3.53,2.37-8.23,3.38-11.76.51-1.77,1.19-4.12,1.69-5.89.71-2.43,1.64-5.68,2.34-8.12-.28,1,.35,2,2,2.92,4.91,2.79,17,4,27.05,2.61,7.67-1,11.9-3.23,11.26-5.46l3.34,11.77,1.67,5.89c.69,2.44,1.62,5.69,2.31,8.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M118.53,330.29c1.29,4.53-7.3,9-22.86,11.1-20.37,2.74-45,.36-55-5.31-3.36-1.91-4.64-3.95-4.07-5.92,1-3.53,2.37-8.24,3.38-11.77.51-1.76,1.19-4.12,1.69-5.88l2.34-8.13c-.46,1.62.58,3.3,3.34,4.86,8.19,4.66,28.37,6.61,45.07,4.36,12.77-1.71,19.81-5.39,18.76-9.1l7.31,25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "143.84 348.93 143.84 348.93 143.84 348.93 143.84 348.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M570.68,341.16c36,4.65,50.8,16.22,33.17,25.84s-61.05,13.66-97,9-50.79-16.22-33.17-25.84S534.73,336.52,570.68,341.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M466.21,354.25c.41-1.77.81-3.55,1.22-5.32a5.05,5.05,0,0,0-.12,1.28,5,5,0,0,1,.12-1.28,10.55,10.55,0,0,1,2.58-4.69c.26-.28.62-.66.91-.92.57-.49,1.34-1.12,1.94-1.57s1.77-1.15,2.54-1.62c1-.54,2.37-1.24,3.41-1.71.89-.41,2.1-.91,3-1.25,1.77-.64,4.18-1.41,6-1.95,1.16-.35,2.74-.74,3.92-1,2.68-.67,7-1.48,8-1.64,1.29-.21,3-.52,4.3-.69,2.69-.36,6.28-.82,9-1.09a226.28,226.28,0,0,1,24.33-1c3.61.06,3.61.06,10,.36,1.48.07,3.45.24,4.93.35s4.54.38,9.73,1c.41.06,4.19.55,8.76,1.43,2.3.44,5.35,1.16,7.62,1.73a70.64,70.64,0,0,1,10.06,3.41,36,36,0,0,1,4.75,2.47,20.42,20.42,0,0,1,3.57,2.72,13.17,13.17,0,0,1,1.38,1.52,11.45,11.45,0,0,1,.91,1.36,8.85,8.85,0,0,1,1,2.52,4.52,4.52,0,0,1,.08.63,4.52,4.52,0,0,0-.08-.63c.42,1.77.83,3.54,1.25,5.32.73,3.16-1.4,6.42-6.79,9.48-16.44,9.34-57,13.26-90.51,8.75C478.62,368.85,464.52,361.61,466.21,354.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M561.49,331.66c31.27,4.2,44.2,14.68,28.86,23.39s-53.13,12.37-84.4,8.16-44.21-14.68-28.87-23.39S530.21,327.45,561.49,331.66Zm-68.81,10.26c-11.12,6.31-1.75,13.9,20.91,16.95s50,.4,61.17-5.92,1.75-13.9-20.92-16.95-50.05-.4-61.16,5.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M521.53,228.76a6.39,6.39,0,0,1,3.1-3.77,14,14,0,0,1,5.47-1.58,29.8,29.8,0,0,1,7.19,0,12.58,12.58,0,0,1,5.61,1.84,6.74,6.74,0,0,1,1.68,1.62,5.89,5.89,0,0,1,.88,1.81c.17.58-.2,1.18-1.19,1.73-2.92,1.66-10.11,2.36-16.06,1.56C523.66,231.4,521.15,230.09,521.53,228.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M579.29,346.36c-1-3.53-2.37-8.24-3.38-11.76-.51-1.77-1.19-4.12-1.69-5.89L570.83,317c-1-3.53-2.36-8.23-3.38-11.76l-1.69-5.89c-1-3.52-2.37-8.23-3.38-11.76L559,275.78c-.5-1.77-1.18-4.12-1.69-5.88-1-3.53-2.36-8.24-3.38-11.77s-2.37-8.23-3.38-11.76c-.51-1.77-1.19-4.12-1.69-5.88-1-3.53-2.37-8.24-3.39-11.77.17.58-.2,1.18-1.19,1.73-2.92,1.66-10.11,2.36-16.06,1.56-4.55-.61-7.06-1.92-6.68-3.25h0c-1,3.54-2.34,8.25-3.34,11.78l-3.34,11.77c-1,3.54-2.34,8.25-3.34,11.78l-3.34,11.77c-1,3.54-2.34,8.25-3.34,11.78l-3.34,11.77-1.67,5.89c-1,3.53-2.33,8.24-3.34,11.78l-3.33,11.77c-.51,1.77-1.17,4.12-1.67,5.89-1,3.53-2.34,8.24-3.34,11.77-1.43,5,8.12,10,25.45,12.36,22.67,3.05,50,.4,61.17-5.92C578.5,350.83,579.92,348.55,579.29,346.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M506.07,283.26c-.86,3.05,4.91,6.06,15.37,7.46,13.69,1.85,30.23.25,36.94-3.57,2.26-1.28,3.12-2.65,2.74-4-1-3.53-2.37-8.23-3.38-11.76-.51-1.77-1.19-4.12-1.69-5.89-.7-2.43-1.64-5.68-2.34-8.12.28,1-.35,2-2,2.92-4.91,2.79-17,4-27.05,2.61-7.67-1-11.89-3.23-11.26-5.46l-3.34,11.77-1.67,5.89c-.69,2.44-1.62,5.69-2.31,8.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M492.74,330.29c-1.29,4.53,7.3,9,22.87,11.1,20.36,2.74,45,.36,54.95-5.31,3.36-1.91,4.64-3.95,4.07-5.92-1-3.53-2.37-8.24-3.38-11.77-.51-1.76-1.19-4.12-1.69-5.88l-2.34-8.13c.47,1.62-.58,3.3-3.34,4.86-8.19,4.66-28.37,6.61-45.07,4.36-12.77-1.71-19.81-5.39-18.76-9.1l-7.31,25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "467.43 348.93 467.43 348.93 467.43 348.93 467.43 348.93"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.7a7063526be5ef00250a1be94178c7ae.svg";
export { ForwardRef as ReactComponent };